import { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { AlbaranesTable } from '../../components/albaranes/AlbaranesTable'
import albaranesService from '../../services/albaranes.service'
import { Button, Stack } from "@mui/material";
import { Link } from 'react-router-dom';

export default function Albaranes() {
  const [rowsState, setRowsState] = useState({
    page: 0,
    pageSize: 50,
    total: 0,
    rows: [],
    loading: true,
  })

  useEffect(() => {
    let active = true;

    setRowsState(prev => ({ ...prev, loading: true }));

    (async () => {
      const results = await albaranesService.getAll({
        page: rowsState.page + 1,
        per_page: rowsState.pageSize,
      });

      if (!active) return;

      setRowsState(prev => ({
        ...prev,
        loading: false,
        rows: results?.albaranes || [],
        total: results?.total || 0,
      }));
    })();

    return () => {
      active = false;
    };
  }, [rowsState.page, rowsState.pageSize]);

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ justifyContent: "space-between", alignItems: "center", my: 2 }}>
        <h3 style={{ margin: 0 }}>Devoluciones</h3>
        <Button
          component={Link}
          to="/historical-albaranes"
          variant="contained"
          color="info"
          size="small"
        >
          Ver Histórico
        </Button>
      </Stack>
      <Helmet>
        <title>Devoluciones - Marina BCN</title>
      </Helmet>
      <AlbaranesTable rowsState={rowsState} setRowsState={setRowsState} />
    </>
  )
}
